import React from 'react'
import { Row, Col } from 'react-bootstrap';
import { toMonetaryFormat } from '../../common/Utilities';
import { PROFIT_NET_OF_TAX_MULTIPLIER } from '../../store/actions/projects/projectCostingActions';

function ProfitAndLoss({
  projectRevenue,
  fullyLoadedCost, 
  externalCost,
  isFullyLoaded, 
  //projectRevenue, 
  onChangeRevenue,
  readOnly
}) {
  projectRevenue = parseFloat(projectRevenue);
  fullyLoadedCost = parseFloat(fullyLoadedCost);
  
  let profitBeforeTax = projectRevenue - (fullyLoadedCost + externalCost);
  let profitNetOfTax = profitBeforeTax * PROFIT_NET_OF_TAX_MULTIPLIER;

  return (
    <>
      <Row>
        <Col><b>Profit and Loss</b></Col>
      </Row>
      <Row>
        <Col xs={3} sm={3} md={3} lg={3} xl={3}>Projected Revenue</Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">{+projectRevenue ? toMonetaryFormat(projectRevenue) : 0.00}</Col>
      </Row>
      <Row>
        <Col xs={3} sm={3} md={3} lg={3} xl={3}>{isFullyLoaded ? 'Fully Loaded Cost' : 'Unloaded Cost'}</Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">{+fullyLoadedCost ? toMonetaryFormat(fullyLoadedCost) : 0.00}</Col>
      </Row>
      <Row>
        <Col xs={3} sm={3} md={3} lg={3} xl={3}>Other Costs</Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">{+externalCost ? toMonetaryFormat(externalCost) : 0.00}</Col>
      </Row>
      <Row>
        <Col xs={3} sm={3} md={3} lg={3} xl={3}>Profit before Tax</Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">{+profitBeforeTax ? toMonetaryFormat(profitBeforeTax): 0.00}</Col>
      </Row>
      <Row>
        <Col xs={3} sm={3} md={3} lg={3} xl={3}>Profit net of Tax</Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">{+profitNetOfTax ? toMonetaryFormat(profitNetOfTax): 0.00}</Col>
      </Row>
    </>
  )
}

export default ProfitAndLoss
